import { render, staticRenderFns } from "./ValveNBCollection.vue?vue&type=template&id=230ec97a&"
import script from "./ValveNBCollection.vue?vue&type=script&lang=js&"
export * from "./ValveNBCollection.vue?vue&type=script&lang=js&"
import style0 from "./ValveNBCollection.vue?vue&type=style&index=0&id=230ec97a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports